<template>
  <v-container v-if="dataLoaded" fluid class="pb-default" style="max-width: 1280px">
    <v-row>
      <v-card-title class="pl-5 pt-5">{{ question.title }} ({{ $t('el.question') }} {{ questionIndex + 1 }} von {{ questionsCount }}) </v-card-title>
    </v-row>
    <v-row>
      <v-col v-if="hasMedia" :cols="mdAndDown ? '12' : '6'">
        <v-card flat class="full-width px-3">
          <v-card-text v-if="hasMedia" class="scroll-container d-flex flex-column">
            <div v-if="hasMultipleMedia" class="d-flex justify-center delimiter-container">
              <v-btn
                fab
                small
                v-for="(item, index) in mediaItems"
                :key="item.id"
                @click="carouselModel = index"
                :color="carouselModel === index ? 'primary' : 'secondary'"
              >
                {{ index + 1 }}
              </v-btn>
            </div>
            <v-carousel
              v-if="mediaItems.length >= 1"
              v-model="carouselModel"
              hide-delimiters
              :show-arrows="showArrows"
              show-arrows-on-hover
              :style="carouselStyle"
            >
              <v-carousel-item v-for="item in mediaItems" :key="item.id">
                <v-img v-if="item.type === 'image'" :src="item.url" contain max-height="500px" :style="carouselStyle" />
                <video-player
                  v-else-if="item.type === 'video'"
                  class="video-player"
                  controls
                  :src="item.url"
                  width="100%"
                  :style="carouselStyle"
                ></video-player>
              </v-carousel-item>
            </v-carousel>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col :cols="mdAndDown || !hasMedia ? '12' : '6'">
        <v-card flat class="full-width px-3">
          <el-question-answers
            :question="question"
            :solutionImageUrl="solutionImageUrl"
            :answersForQuestion="answersForQuestion"
            :revealSolution="solutionRevealed"
            @onAnswersValidityChange="onAnswersValidityChange"
          >
          </el-question-answers>
        </v-card>
      </v-col>
    </v-row>

    <!-- <transition name="slide"> -->

    <div :style="xs ? 'height:50px;padding-top:10px' : 'height:60px;padding-right:40px'" class="fab-buttons d-flex justify-end background">
      <v-btn v-if="isTraining" rounded :color="theme.elements.btnColor" :class="theme.elements.btnTextClz" class="ml-2" @click="$emit('onPrevious')">
        <v-icon v-if="!xs" small class="mr-2">mdi-step-backward</v-icon>
        {{ $t('back') }}
      </v-btn>
      <v-btn v-if="isTraining" rounded :color="theme.elements.btnColor" :class="theme.elements.btnTextClz" class="ml-2" @click="elmx_backToHome">
        <v-icon v-if="!xs" small class="mr-2">mdi-pause-circle</v-icon>
        {{ $t('el.interrupt') }}
      </v-btn>

      <v-btn rounded color="success" :disabled="mode.disabled" :width="mode.next === 'next' ? '160' : ''" class="ml-2" @click="performNext()">
        <v-icon v-if="!xs" small class="mr-2">{{ mode.icon }}</v-icon>
        {{ $t(mode.text) }}
      </v-btn>
    </div>

    <!-- </transition> -->
  </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import config from '@/common/config';
import commonMixin from '@/mixins/common';
import elearningMixin from './ElearningMixin';
import index from './index.js';
import ElQuestionAnswers from './ElearningQuestionAnswers';
import VideoPlayer from '@/components/VideoPlayer';

export default {
  name: 'ELQuestion',
  components: {
    ElQuestionAnswers,
    VideoPlayer,
  },
  mixins: [commonMixin, elearningMixin],
  props: {
    module: Object,
    question: Object,
    questionIndex: Number,
    questionsCount: Number,
    showSolution: Boolean,
  },

  data() {
    return {
      answerModels: {},
      correctionEnabled: true,
      isFormValid: false,
      solutionRevealed: false,
      carouselModel: null,
      maxCarouselHeight: 500,
      isSmallScreen: window.innerHeight < 880,
    };
  },
  mounted() {
    this.onWindowResize();
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  computed: {
    ...mapState('elearning', ['answers', 'medias', 'answersByQuestionId', 'userAnswersByQuestionId', 'dataLoaded']),
    isTraining() {
      return this.module.is_practice === 1;
    },
    answersForQuestion() {
      console.debug('calculate answers for question with id=', this.question.id);
      return this.answersByQuestionId[this.question.id] || [];
    },
    questionMedias() {
      return this.medias.filter((m) => m.questionIdFk === this.question.id);
    },
    images() {
      let images = this.questionMedias.filter((m) => m.type === 'image');
      return images;
    },
    solutionImageUrl() {
      let images = this.questionMedias.filter((m) => m.type === 'solution_image');
      return images.length > 0 ? this.imageUrl(images[0]) : null;
    },
    videos() {
      let videos = this.questionMedias.filter((m) => m.type === 'video');
      return videos;
    },
    hasMedia() {
      return this.images.length + this.videos.length > 0;
    },

    /**
     * True to indicate the user has already filled at least one answer
     */
    hasAnswers() {
      if (!this.userAnswersByQuestionId[this.question.id]) return false;
      return Object.keys(this.userAnswersByQuestionId[this.question.id]).length > 0;
    },

    /**
     * Only one answer option is given, that is no solution must be revealed
     */
    oneAnswer() {
      return this.answersForQuestion && this.answersForQuestion.length === 1;
    },
    hasNoAnswers() {
      return !this.answersForQuestion || this.answersForQuestion.length === 0;
    },
    mode() {
      return getMode(this.showSolution, this.hasAnswers && this.isFormValid, this.oneAnswer, this.solutionRevealed, this.hasNoAnswers);
    },
    hasMultipleMedia() {
      return this.mediaItems.length > 1;
    },
    carouselStyle() {
      if (this.isSmallScreen) {
        return { height: this.maxCarouselHeight + 'px' };
      } else {
        return { height: '500px' };
      }
    },
    mediaItems() {
      let items = [];
      for (let image of this.images) {
        items.push({ id: image.id, url: this.imageUrl(image), type: 'image' });
      }
      for (let video of this.videos) {
        items.push({ id: video.id, url: this.videoUrl(video), type: 'video' });
      }
      return items;
    },
    showArrows() {
      // only show arrows if there are multiple media items and the current item is an image
      const currentItem = this.mediaItems[this.carouselModel];
      return this.hasMultipleMedia && currentItem && currentItem.type === 'image';
    },
  },
  methods: {
    ...mapMutations('elearning', ['freezeUserAnswer']),
    imageUrl(image) {
      return `${config.apiUrl}/medias/${index.api}/${image.filename}/${image.checksum}`;
    },

    videoUrl(video) {
      return `${config.apiUrl}/medias/${index.api}/${video.filename}/${video.checksum}`;
    },

    onAnswersValidityChange(value) {
      this.isFormValid = value;
    },
    performNext() {
      console.debug('performNext with', this.mode.next);
      if (this.mode.next === 'next') {
        this.freezeUserAnswer({ questionId: this.question.id });
        this.$emit('onNext');
      } else {
        switch (this.mode.next) {
          case 'fillingIn':
            // hasAnswers set to true ==> is calculated
            this.solutionRevealed = false;
            return;
          case 'revealSolution':
            this.solutionRevealed = true;
            this.freezeUserAnswer({ questionId: this.question.id });
            return;
          case 'next':
            console.debug('should never land here');
        }
      }
    },
    onWindowResize() {
      this.maxCarouselHeight = window.innerHeight - 300 - 100;
      this.isSmallScreen = window.innerHeight < 880;
    },
  },
};

/**
 * Detects the current mode based on the four provided states.
 * The flow of modes is as following:
 * in case solutions get displayed:displayedOnly, fillingIn, revealSolution,next
 * in case no solutions get displayed: displayedOnly, fillingIn,next
 * The meaning of the states is this:
 * displayedOnly: Answer options are displayed but no choice has been taken
 * fillingIn: At least one option is selected
 * oneAnswer: There is only one answering option and thus no solution to be displayed. Used for the case a module contains a "please accept 'question'"
 * revealSolution: the solution gets revealed
 * next: transition to the next slide happens.
 * @param {boolean} showSolution The solution is displayed in this module
 * @param {boolean} hasAnswers The user has taken at least one choice
 * @param {boolean} oneAnswer Only one answer option
 * @param {boolean} solutionRevealed The solution is currently displayed
 * @param hasNoAnswers
 * @returns {object} an object with the name of the mode, the next property, that is the name of the next mode, disabled to indicate when the next action should be disabled, icon and text properties for button display.
 */
export function getMode(showSolution, hasAnswers, oneAnswer, solutionRevealed, hasNoAnswers) {
  let revealSolutionReply = { icon: 'mdi-check-circle', text: 'el.revealSolution' };
  let nextReply = { icon: 'mdi-step-forward', text: 'el.next' };

  const map = [
    {
      showSolution: true,
      hasAnswers: false,
      oneAnswer: false,
      solutionRevealed: false,
      hasNoAnswers: true,
      name: 'displayedOnly',
      next: 'next',
      disabled: false,
      ...nextReply,
    },
    {
      showSolution: false,
      hasAnswers: false,
      oneAnswer: false,
      solutionRevealed: false,
      hasNoAnswers: false,
      name: 'displayedOnly',
      next: 'fillingIn',
      disabled: true,
      ...nextReply,
    },
    {
      showSolution: false,
      hasAnswers: false,
      oneAnswer: true,
      solutionRevealed: false,
      hasNoAnswers: false,
      name: 'displayedOnly',
      next: 'next',
      disabled: true,
      ...nextReply,
    },
    {
      showSolution: false,
      hasAnswers: true,
      oneAnswer: false,
      solutionRevealed: false,
      hasNoAnswers: false,
      name: 'fillingIn',
      next: 'next',
      ...nextReply,
    },
    {
      showSolution: false,
      hasAnswers: true,
      oneAnswer: true,
      solutionRevealed: false,
      hasNoAnswers: false,
      name: 'fillingIn',
      next: 'next',
      ...nextReply,
    },

    {
      showSolution: true,
      hasAnswers: false,
      oneAnswer: false,
      solutionRevealed: false,
      hasNoAnswers: false,
      name: 'displayedOnly',
      next: 'fillingIn',
      disabled: true,
      ...revealSolutionReply,
    },
    {
      showSolution: true,
      hasAnswers: false,
      oneAnswer: true,
      solutionRevealed: false,
      hasNoAnswers: false,
      name: 'displayedOnly',
      next: 'fillingIn',
      disabled: true,
      ...revealSolutionReply,
    },
    {
      showSolution: true,
      hasAnswers: false,
      oneAnswer: false,
      solutionRevealed: true,
      hasNoAnswers: false,
      name: 'revealSolution',
      next: 'next',
      ...nextReply,
    },
    {
      showSolution: true,
      hasAnswers: true,
      oneAnswer: false,
      solutionRevealed: false,
      hasNoAnswers: false,
      name: 'fillingIn',
      next: 'revealSolution',
      ...revealSolutionReply,
    },
    {
      showSolution: true,
      hasAnswers: true,
      oneAnswer: true,
      solutionRevealed: false,
      hasNoAnswers: false,
      name: 'fillingIn',
      next: 'next',
      ...nextReply,
    },
    {
      showSolution: true,
      hasAnswers: true,
      oneAnswer: false,
      solutionRevealed: true,
      hasNoAnswers: false,
      name: 'revealSolution',
      next: 'next',
      ...nextReply,
    },
  ];
  let selectedMode = map.find(
    (r) =>
      r.showSolution === showSolution &&
      r.hasAnswers === hasAnswers &&
      r.oneAnswer === oneAnswer &&
      r.solutionRevealed === solutionRevealed &&
      r.hasNoAnswers === hasNoAnswers
  );
  if (!selectedMode) {
    console.debug(
      'mode undefined for showSolution:',
      showSolution,
      ',hasAnswers:',
      hasAnswers,
      ',oneAnswer:',
      oneAnswer,
      ',solutionRevealed:',
      solutionRevealed
    );
  }
  return selectedMode;
}
</script>
<style scoped>
.img {
  size: cover;
}

.border {
  border: 0px solid #505050;
  border-radius: 15px;
  overflow: hidden;
}

.fab-buttons {
  position: absolute !important;
  z-index: 1000000 !important;
  left: 0 !important;
  right: 0px !important;
  bottom: -1px !important;
  padding-top: 10px;
  opacity: 0.8;
}

.delimiter-container {
  gap: 35px;
  margin-bottom: 10px;
}

.video-player {
  background-color: transparent !important;
}
</style>
<!-- Adapt styles given by cockpit. Cannot be scoped in this case -->
<style>
.question h1 {
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
}

.question h2 {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.03125em;
}

.question h3 {
  font-size: 0.97rem;
  font-weight: 400;
  letter-spacing: 0.03125em;
}

.question pre {
  font-size: 0.95rem;
  white-space: pre-line;
}
</style>
